/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Precision {
  /**
   * Output a number rounded up to a fixed number of decimal points
   *
   * @public
   * @function f1.precision
   * @param decimalPoints the decimal points allowed in the number output
   * @param value the real number to limit by decimal points
   * @example
   *
   * ```ts
   * f1.precision(2, 3) => 3 // because it is an integer
   * f1.precision(2, 3.1234) => 3.12
   * f1.precision(6, 3.1234) => 3.1234 // no padding because it is a number
   * ```
   */
  (decimalPoints: number, value: number): number;
  /**
   * {@link FnPrecisionValue}
   * @param decimalPoints the decimal points allowed in the number output
   */
  (decimalPoints: number): (value: number) => number;
}

/**
 * @see Precision
 */
export default (decimalPoints: number, value: number) => {
  const f = Math.pow(10, decimalPoints);

  return Math.round(value * f) / f;
};
